// extracted by mini-css-extract-plugin
export default {"embed":"diIOOwSRPt"};